import { ReactNode } from 'react';
import { ListItem, ListItemText, Avatar, Dialog, ListItemButton, useTheme } from '@mui/material';
import { useState } from 'react';
import { Connection } from '@domain/connection/models/Connection';
import { APP_CONFIG } from '../../../../config/app.config';
import { ConnectionAuthStatus } from '@features/connections/generic/components/ConnectionAuthStatus';
import ProductFlowCredentialsForm from './ProductFlowCredentialsForm';
import ProductFlowConnectionSettings from './ProductFlowConnectionSettings';
import { Icon } from '@shared/icons';

export interface ProductFlowConnectionListItemProps {
    connection: Connection;
    onClick?: (settings: ReactNode) => void;
}

export const ProductFlowConnectionListItem = ({ connection, onClick }: ProductFlowConnectionListItemProps) => {
    const [reconnectOpen, setReconnectOpen] = useState(false);
    const theme = useTheme();

    const handleClick = onClick
        ? () => onClick(<ProductFlowConnectionSettings connectionId={connection.id} />)
        : undefined;

    const content = (
        <>
            <Avatar
                sx={{ width: 60, height: 60, border: 1, borderColor: APP_CONFIG.ui.theme.colors.border, backgroundColor: theme.palette.background.paper }}
                variant="rounded"
                alt={connection.connector.type}
                slotProps={{ img: { style: { objectFit: 'contain' } } }}
                src={connection.connector.image}
            />

            <ListItemText primary={connection.name} secondary={connection.connector.type} />

            <ConnectionAuthStatus authorized={connection.authorized} active={connection.active} onReconnect={() => setReconnectOpen(true)} />

            {onClick && (
                <Icon icon="ChevronRight" color={theme.palette.text.secondary} />
            )}

            <Dialog open={reconnectOpen} onClose={() => setReconnectOpen(false)} maxWidth="sm" fullWidth>
                <ProductFlowCredentialsForm
                    reconnectConnectionId={connection.id}
                    onNewConnection={() => setReconnectOpen(false)}
                    onClose={() => setReconnectOpen(false)}
                />
            </Dialog>
        </>
    );

    if (handleClick) {
        return (
            <ListItemButton sx={{ p: 2, gap: 2 }} onClick={handleClick}>
                {content}
            </ListItemButton>
        );
    }

    return (
        <ListItem sx={{ p: 2, gap: 2 }}>
            {content}
        </ListItem>
    );
};
